import { gql } from '@apollo/client'

export const GetSmartReportsQuery = gql`
    query GetSmartReportsStatus($input: GetBackendProcessStatusInput!) {
        getGenerateReportStatus(input: $input) {
            errorMessage
            progressPercentage
            result {
                reportRowDivisions {
                    groupId
                    name
                }
                reportRows {
                    id
                    article
                    assembly
                    dataDescription
                    dataTitle
                    dataType
                    division
                    divisionGroupId
                    drawingDesignation
                    familyElementId
                    firmId
                    lastUpdate
                    partitionKey
                    productSelection
                    productType
                    productTypeElementId
                    projectId
                    projectProductFamilyId
                    reportType
                    section
                    sectionSource
                    shouldSerializeFirmId
                    shouldSerializePartitionKey
                    siteId
                    tag
                    userId
                }
                lastUpdate
            }
            state
        }
    }
`
export const GetGeneratedReport = gql`
    query GetGeneratedReports($input: GenerateReportInput) {
        getGeneratedReports(input: $input) {
            result {
                reportRowDivisions {
                    groupId
                    name
                }
                reportRows {
                    id
                    article
                    assembly
                    dataDescription
                    dataTitle
                    dataType
                    division
                    divisionGroupId
                    drawingDesignation
                    familyElementId
                    firmId
                    lastUpdate
                    partitionKey
                    productSelection
                    productType
                    productTypeElementId
                    projectId
                    projectProductFamilyId
                    reportType
                    section
                    sectionSource
                    shouldSerializeFirmId
                    shouldSerializePartitionKey
                    siteId
                    tag
                    userId
                }
                lastUpdate
            }
        }
    }
`
export const ExportGeneratedReports = gql`
    query exportGeneratedReports($input: GenerateReportInput!) {
        exportGeneratedReports(input: $input) {
            totalCount
            file
        }
    }
`
